/* RESPONSIBLE TEAM: team-self-serve */

import {
  PROACTIVE_SUPPORT_PLUS_BASE_ID,
  FIN_AI_COPILOT_BASE_ID,
  PERFORMANCE_PRO_BASE_ID,
} from 'embercom/lib/billing';

export const EARLY_STAGE_ADDON_DISPLAY_ORDER = [
  FIN_AI_COPILOT_BASE_ID,
  PERFORMANCE_PRO_BASE_ID,
  PROACTIVE_SUPPORT_PLUS_BASE_ID,
] as const;
